<template>
  <sweet-modal ref="modal" title="Customer specific attributes">
    <div v-if="capability">
      <div class="form-group row" v-for="(value, key) in capability.customer_specific_attributes">
        <label class="col-sm-5 col-form-label">{{ labels[key] }}</label>
        <div class="col-sm-7">
          <input class="form-control" v-model="capability.customer_specific_attributes[key]" :ref="key" />
        </div>
      </div>
      <button class="mt-2 btn btn-primary" @click="save(capability)">{{ 'save' | t }}</button>
    </div>
  </sweet-modal>
</template>
<script>
import _ from 'lodash';
import Alerts, { handle } from '@/utils/alerts';
import Api from '@/store/jsonapi';

export default {
  props: [''],
  data: function () {
    return {
      capability: {},
      labels: {}
    };
  },
  methods: {
    open: function (capability) {
      this.capability = capability;
      let attributes = {};
      _.each(_.filter(this.capability.local_attrs, 'is_required'), (local_attribute) => {
        this.labels[local_attribute.attr_key] = local_attribute.attr_name;
        attributes[local_attribute.attr_key] = '';
      });
      this.capability.customer_specific_attributes = attributes;
      this.$refs.modal.open();
    },
    save: function (capability) {
      this.$emit('load_custom_services', capability);
      this.close();
    },
    close: function () {
      this.$refs.modal.close();
    }
  }
};
</script>
